(function ($) {

	// Content product - change image on color variation hover

	var current_name = ""

	function switch_variation() {
		let variation_data = $(this).data("product"),
			$variation_title = $(this).closest(".products_item").find(".products_item__color_name"),
			$variation_content = $(this).closest(".products_item").find(".products_item__content")

		// If variation data is not set
		if (!variation_data) {
			return;
		}

		// Set as active
		$(this).siblings(".current").removeClass("current")
		$(this).addClass("current")

		// Switch content
		if (variation_data.content) {
			$variation_content.replaceWith(variation_data.content)
		}

		// Switch name
		if (variation_data.title) {
			current_name = variation_data.title
			$variation_title.text(variation_data.title)
		}
	}

	function variation_name_preview() {
		let variation_data = $(this).data("product"),
			$variation_title = $(this).closest(".products_item").find(".products_item__color_name")

		current_name = $variation_title.text()
		$variation_title.text(variation_data.title)
	}

	function variation_name_undo_preview() {
		let $variation_title = $(this).closest(".products_item").find(".products_item__color_name")
		$variation_title.text(current_name)
	}

	function init_variations() {
		$(".products_item__color").hover(variation_name_preview, variation_name_undo_preview); // bind event again
		$(".products_item__color").click(switch_variation); // bind event again
	}

	init_variations()

})(jQuery);